import React from 'react';
import TenantLookup from '../tenant-lookup/TenantLookup';

const App = () => {
  return <TenantLookup />;
};

export default App;
